<template>
  <Layout>
    <modal v-if="showModal" />
    <div class="fm d-flex flex-column" v-bind:class="{ 'fm-full-screen': fullScreen }">
      <navbar v-if="false" />
      <div class="fm-body">
        <notification />
        <context-menu />
        <global-context-menu />
        <template v-if="windowsConfig === 1">
          <left-manager manager="left" />
        </template>
        <template v-else-if="windowsConfig === 2">
              <!-- <folder-tree /> -->
            <SplitArea :size="80" class="scroll">
              <left-manager manager="left" />
            </SplitArea>
        </template>
        <template v-else-if="windowsConfig === 3">
          <left-manager class="col-12 col-sm-6" manager="left" v-on:click.native="selectManager('left')"
            v-on:contextmenu.native="selectManager('left')">
          </left-manager>
          <right-manager class="col-12 col-sm-6" manager="right" v-on:click.native="selectManager('right')"
            v-on:contextmenu.native="selectManager('right')">
          </right-manager>
        </template>
      </div>
      <info-block />
    </div>
  </Layout>
</template>

<script>
/* eslint-disable import/no-duplicates, no-param-reassign */
import { mapState } from 'vuex';
// Axios

import Layout from "../../layouts/main";
import i18n from "../../../i18n";
import HTTP from './http/axios'; 
import EventBus from '../../../components/eventBus';
// Components
import Navbar from '../../../components/blocks/Navbar.vue';
import LeftManager from '../../../components/manager/Manager.vue';
import RightManager from '../../../components/manager/Manager.vue';
// import FolderTree from '../../../components/tree/FolderTree.vue';
import Modal from '../../../components/modals/Modal.vue';
import InfoBlock from '../../../components/blocks/InfoBlock.vue';
import ContextMenu from '../../../components/blocks/ContextMenu.vue';
import GlobalContextMenu from '../../../components/blocks/GlobalContextMenu.vue';
import Notification from '../../../components/blocks/Notification.vue';
// Mixins

export default {
  name: 'FileManager',
  components: {
    Layout,
    Navbar,    
    LeftManager,
    RightManager,
    Modal,
    InfoBlock,
    ContextMenu,
    GlobalContextMenu,
    Notification,
    // FolderTree,
  },
  data() {
    return {
      settings: {
        // axios headers
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${this.getToken()}`,
        },
        baseUrl: process.env.VUE_APP_DEFAULT_URL+'/file-manager/',   
        windowsConfig: 2,                           
        lang: i18n.locale,                                                 
      },
    }
  },
  created() {
    // manual settings
    this.$store.commit('settings/manualSettings', this.settings);
    this.$store.commit(`left/setDirectoryContent`, { directories : [], files : []})


    // initiate Axios
    this.$store.commit('settings/initAxiosSettings');
    this.requestInterceptor();
    this.responseInterceptor();

    // initialize app settings
    this.$store.dispatch('initializeApp');

    /**
     * todo Keyboard event
     */
    /*
    window.addEventListener('keyup', (event) => {
      event.preventDefault();
      event.stopPropagation();

      EventBus.$emit('keyMonitor', event);
    });
    */
  },
  destroyed() {
    // reset state
    this.$store.dispatch('resetState');

    // delete events
    EventBus.$off(['contextMenu', 'addNotification']);
  },
  computed: {
    ...mapState({
      windowsConfig: (state) => state.settings.windowsConfig,
      activeManager: (state) => state.settings.activeManager,
      showModal: (state) => state.modal.showModal,
      fullScreen: (state) => state.settings.fullScreen,
    }),
    showFileDetail() {
      return this.$store.state.left.showFileDetail;
    }

  },
  methods: {
      getToken() {
        let user = JSON.parse(localStorage.getItem('user'))
        if (user && user.token) {
            return user.token
        } else {
            return null
        }
      },
    /**
     * Add axios request interceptor
     */
    requestInterceptor() {
      HTTP.interceptors.request.use((config) => {
        // overwrite base url and headers
        config.baseURL = this.$store.getters['settings/baseUrl'];
        config.headers = this.$store.getters['settings/headers'];

        // loading spinner +
        this.$store.commit('messages/addLoading');

        return config;
      }, (error) => {
        // loading spinner -
        this.$store.commit('messages/subtractLoading');
        return Promise.reject(error);
      });
    },

    /**
     * Add axios response interceptor
     */
    responseInterceptor() {
      HTTP.interceptors.response.use((response) => {
        // loading spinner -
        this.$store.commit('messages/subtractLoading');

        // create notification, if find message text
        if (Object.prototype.hasOwnProperty.call(response.data, 'result')) {
          if (response.data.result.message) {
            const message = {
              status: response.data.result.status,
              message: Object.prototype.hasOwnProperty.call(this.$t('filemanager.response'), response.data.result.message)
                ? this.$t('filemanager.response.'+response.data.result.message)
                : response.data.result.message,
            };

            // show notification
            EventBus.$emit('addNotification', message);

            // set action result
            this.$store.commit('messages/setActionResult', message);
          }
        }

        return response;
      }, (error) => {
        // loading spinner -
        this.$store.commit('messages/subtractLoading');

        const errorMessage = {
          status: 0,
          message: '',
        };

        const errorNotificationMessage = {
          status: 'error',
          message: '',
        };

        // add message
        if (error.response) {
          errorMessage.status = error.response.status;

          if (error.response.data.message) {
            const trMessage = Object.prototype.hasOwnProperty.call(this.$t('filemanager.response'), error.response.data.message)
              ? this.$t('filemanager.response.'+error.response.data.message)
              : error.response.data.message;

            errorMessage.message = trMessage;
            errorNotificationMessage.message = trMessage;
          } else {
            errorMessage.message = error.response.statusText;
            errorNotificationMessage.message = error.response.statusText;
          }
        } else if (error.request) {
          errorMessage.status = error.request.status;
          errorMessage.message = error.request.statusText || 'Network error';
          errorNotificationMessage.message = error.request.statusText || 'Network error';
        } else {
          errorMessage.message = error.message;
          errorNotificationMessage.message = error.message;
        }

        // set error message
        this.$store.commit('messages/setError', errorMessage);

        // show notification
        EventBus.$emit('addNotification', errorNotificationMessage);

        return Promise.reject(error);
      });
    },

    /**
     * Select manager (when shown 2 file manager windows)
     * @param managerName
     */
    selectManager(managerName) {
      if (this.activeManager !== managerName) {
        this.$store.commit('setActiveManager', managerName);
      }
    },
  },
};
</script>

<style lang="scss">
  @import "~plyr/src/sass/plyr.scss";
  .fm {
    position: relative;
    height: 100%;
    padding: 4px;
    background-color: white;
    border-radius: 10px;

    &:-moz-full-screen {
      background-color: white;
    }

    &:-webkit-full-screen {
      background-color: white;
    }

    &:fullscreen {
      background-color: white;
    }

    .fm-body {
      display: flex;
      height: calc( 100vh - 140px );
      margin-right: -30px;
      margin-left: -30px;
      position: relative;
      // padding-top: 1rem;
      // padding-bottom: 1rem;
      // border-top: 5px solid #f1f5fa;
      border-bottom: 6px solid #f1f5fa;
    }

    .unselectable {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }

  .fm-error {
    color: white;
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .fm-danger {
    color: #dc3545;
    background-color: white;
    border-color: #dc3545;
  }

  .fm-warning {
    color: #ffc107;
    background-color: white;
    border-color: #ffc107;
  }

  .fm-success {
    color: #28a745;
    background-color: white;
    border-color: #28a745;
  }

  .fm-info {
    color: #17a2b8;
    background-color: white;
    border-color: #17a2b8;
  }

  .fm.fm-full-screen {
    width: 100%;
    height: 100%;
    padding-bottom: 0;
  }
</style>
